import { render } from "./EditWorksheetPage.vue?vue&type=template&id=12177148"
import script from "./EditWorksheetPage.vue?vue&type=script&lang=js"
export * from "./EditWorksheetPage.vue?vue&type=script&lang=js"

import "./EditWorksheetPage.vue?vue&type=style&index=0&id=12177148&lang=css"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__